import React from 'react';
import { Route, Switch } from 'react-router-dom';
import FreecodeTestInspectPage from '../user/containers/FreecodeTestInspect/FreecodeTestInspect';
import FreecodeChallengePage from '../user/containers/FreecodeChallenge/FreecodeChallenge';
import FreecodeTestTrialPage from '../user/containers/FreecodeTestTrial/FreecodeTestTrial';
import FreecodeExercisePage from '../user/containers/FreecodeExercise/FreecodeExercise';
import FreecodeCreatorPage from '../user/containers/FreecodeCreator/FreecodeCreator';
import FreecodeTestPage from '../user/containers/FreecodeTest/FreecodeTest';
import CandidateFeedbackPage from '../user/containers/CandidateFeedbackPage';
import HandleStripeResponse from '../user/screens/payment/handleStripeResponse';
import PaymentLandingPage from '../user/screens/payment/paymentLandingPage';
import CodeChallenge from '../user/containers/CodeChallenge/CodeChallenge';
import SubscriptionPlans from '../user/screens/payment/subscriptionPlans';
import MultichoiceTestPage from '../user/containers/MultichoiceTestPage/MultichoiceTestPage';
import ChallengeListPage from '../user/containers/ChallengeListPage';
import ResetPasswordPage from '../user/containers/ResetPasswordPage';
import AchievementsPage from '../user/containers/AchievementsPage/AchievementPage';
import CustomTestsPage from '../user/containers/CustomTestsPage/CustomTestsPage';
import SetPasswordPage from '../user/containers/SetPasswordPage/SetPasswordPage';
import RecruitmentPage from '../user/containers/RecruitmentPage';
import ChallengePage from '../user/containers/ChallengePage';
import MembershipPage from '../user/containers/MembershipPage/MembershipPage';
import CandidateInfo from '../user/screens/cmsCandidateInfo/cmsCandidateInfo';
import RedirectPage from '../user/containers/RedirectPage/RedirectPage';
import AllChallenges from '../user/screens/cmsAllChallenges/cmsAllChallenges';
import NotFoundPage from '../user/containers/NotFoundPage/NotFoundPage';
import ProfilePage from '../user/containers/ProfilePage';
import AllContests from '../user/screens/cmsAllContests/cmsAllContests';
import LandingPage from '../user/containers/LandingPage/LandingPage';
import CookiesPage from '../user/containers/CookiesPage/CookiesPage';
import ContactPage from '../user/containers/ContactPage/ContactPage';
import Statistics from '../user/containers/StatisticsPage';
import PolicyPage from '../user/containers/PolicyPage';
import SignupPage from '../user/containers/SignupPage';
import CodeSubmit from '../user/screens/codeSubmit';
import LoginPage from '../user/containers/LoginPage';
import AboutPage from '../user/containers/AboutPage/AboutPage';
import Hackathon from '../user/containers/Hackathon/Hackathon';
import HackathonMatches from '../user/containers/HackathonMatches/HackathonMatches';
import Payments from '../user/containers/PaymentsPage';
import FAQPage from '../user/containers/FAQPage/FAQPage';
import CandidateTicketsPage from '../user/containers/CandidateTicketsPage/CandidateTicketsPage';
import TicketSessionPage from '../user/containers/TicketSessionPage';
import SettingsPage from '../user/containers/SettingsPage';
import Contest from '../user/screens/cmsContest';
import Result from '../user/screens/cmsResult';
import SuperAdminPage from '../user/containers/SuperAdminPage';
import DepartmentSettingsPage from '../user/containers/SettingsPage/DepartmentSettingsPage';
import ReportPage from '../user/containers/ReportPage/ReportPage';
import XPPage from '../user/containers/XPPage/XP';
import QuestionFeedbackPage from '../user/containers/QuestionFeedbackPage/QuestionFeedback';
import SendTestPage from '../user/containers/SendTestPage';
import UnsubscribePage from '../user/containers/UnsubscribePage/UnsubscribePage';

import FreecodeRoute from './FreecodeRoute';
import CommunityRoute from './CommunityRoute';
import CompanyRoute from './CompanyRoute';
import Path from './Path';
import App from '../App';

export const Router = () => {
  return (
    <App>
      <Switch>
        <CommunityRoute path={Path.landingPage} exact component={LandingPage} />
        <CompanyRoute path={Path.codeSubmit} exact component={CodeSubmit} />
        <CompanyRoute path={Path.AllChallenges} exact component={AllChallenges} authMode="private" />
        <CompanyRoute path={Path.contest} exact component={Contest} />
        <CompanyRoute path={Path.allContest} exact component={AllContests} />
        <CompanyRoute path={Path.result} exact component={Result} />
        <CompanyRoute path={Path.candidateInfo} exact component={CandidateInfo} />
        <CommunityRoute path={Path.aboutPage} exact component={AboutPage} zendesk="open" />
        <CommunityRoute path={Path.contactPage} exact component={ContactPage} zendesk="open" />
        <CommunityRoute path={Path.membershipPage} exact component={MembershipPage} />
        <CommunityRoute path={Path.cookiesPage} exact component={CookiesPage} />
        <CommunityRoute path={Path.policyPage} exact component={PolicyPage} />
        <CommunityRoute path={Path.faqPage} exact component={FAQPage} />
        <CommunityRoute path={Path.challengeListPage} exact component={ChallengeListPage} />
        <CommunityRoute path={Path.challengeLandingPage} exact component={ChallengePage} />
        <FreecodeRoute path={Path.freecodeExercisePage} exact component={FreecodeExercisePage} />
        <FreecodeRoute path={Path.freecodeChallengePage} exact component={FreecodeChallengePage} />
        <FreecodeRoute path={Path.freecodeCreatorPage} exact component={FreecodeCreatorPage} />
        <FreecodeRoute path={Path.freecodeTestTrialPage} exact component={FreecodeTestTrialPage} />
        <FreecodeRoute path={Path.freecodeTestPage} exact component={FreecodeTestPage} />
        <FreecodeRoute path={Path.freecodeTestInspectPage} exact component={FreecodeTestInspectPage} />
        <CommunityRoute path={Path.recruitmentPage} exact component={RecruitmentPage} zendesk="open" />
        <Route path={Path.hackathon} exact component={Hackathon} />
        <CommunityRoute path={Path.codeChallenge} exact component={CodeChallenge} />
        <Route path={Path.hackathonMatches} exact component={HackathonMatches} />
        <CompanyRoute path={Path.ticketSessionPage} exact component={TicketSessionPage} />
        <CompanyRoute path={Path.candidateTicketsPage} exact component={CandidateTicketsPage} />
        <CommunityRoute path={Path.notFoundPage} exact component={NotFoundPage} />
        <CompanyRoute path={Path.superadmin} authMode="private" exact component={SuperAdminPage} zendesk="hide" />
        <CommunityRoute path={Path.profilePage2} authMode="private" exact component={ProfilePage} />
        <CommunityRoute path={Path.profilePage} authMode="private" exact component={ProfilePage} />
        <CompanyRoute path={Path.candidateFeedbackPage} authMode="private" exact component={CandidateFeedbackPage} />
        <CompanyRoute path={Path.statistics} authMode="private" exact component={Statistics} />
        <CommunityRoute path={Path.achievementPage} authMode="private" exact component={AchievementsPage} />
        <CommunityRoute path={Path.xpPage} authMode="private" exact component={XPPage} />
        <CommunityRoute path={Path.loginPage} authMode="unauthed" exact component={LoginPage} />
        <CommunityRoute path={Path.signupPage} authMode="unauthed" exact component={SignupPage} />
        <CommunityRoute path={Path.resetPasswordPage} authMode="unauthed" exact component={ResetPasswordPage} />
        <CommunityRoute path={Path.setPasswordPage} authMode="unauthed" exact component={SetPasswordPage} />
        <CompanyRoute path={Path.multichoice} authMode="private" exact component={MultichoiceTestPage} zendesk="hide" />
        <CompanyRoute path={Path.customTests} authMode="private" exact component={CustomTestsPage} />
        <CompanyRoute path={Path.settings} authMode="private" exact component={SettingsPage} />
        <CompanyRoute path={Path.departmentSettings} authMode="private" exact component={DepartmentSettingsPage} />
        <CompanyRoute path={Path.report} exact component={ReportPage} />
        <CompanyRoute path={Path.downloadReport} exact component={ReportPage} zendesk="hide" />
        {/* Payments path */}
        <CompanyRoute path={Path.handleStripeResponse} exact component={HandleStripeResponse} />
        <CompanyRoute path={Path.paymentLandingPage} component={PaymentLandingPage} />
        <CompanyRoute path={Path.subscriptionPlans} exact component={SubscriptionPlans} />
        <CompanyRoute path={Path.sendTestPage} exact component={SendTestPage} />
        <CompanyRoute
          path={Path.questionFeedbackPage}
          authMode="private"
          exact
          component={QuestionFeedbackPage}
          zendesk="hide"
        />
        <CompanyRoute path={Path.payments} authMode="private" exact component={Payments} />
        <CommunityRoute path={Path.unsubscribe} exact component={UnsubscribePage} />
        <CommunityRoute path={Path.redirect} exact component={RedirectPage} />
        <CommunityRoute path={Path.defaultHandler} exact component={NotFoundPage} />
      </Switch>
    </App>
  );
};
